// This lists options that apply to packages. The option names/keys are used to get translations from .properties files.
// Example: "skipass" in this config takes "planningSummary_options_skipass" content from translation

export default {
    HS: [],
    PF: ["skipass"],
    PFCS: ["skipass"],
    PFP: ["skipass", "materiel"],
    PFPCS: ["skipass", "materiel"],

    HF: ["flight", "transport"],
    PFF: ["flight", "transport","skipass"],
    PFPF: ["flight", "transport", "skipass", "materiel"],

    HTT: ["train", "transport"],
    HTTF: ["train", "transport"],
    HTT_PLUS1: ["train", "transport", "home", "night"],
    
    PFTT: ["train", "transport", "skipass"],
    PFTTF: ["train", "transport", "skipass"],
    PFTTNL: ["train", "transport", "skipass"],
    PFTTUK: ["train", "transport", "skipass"],
    
    PFPTT: ["train", "transport", "skipass", "materiel"],
    PFPTTF: ["train", "transport", "skipass", "materiel"],
    PFPTTNL: ["train", "transport", "skipass", "materiel"],
    PFPTTUK: ["train", "transport", "skipass", "materiel"],

    PFTT_7: ["train", "transport", "skipass"],
    PFTT_8: ["train", "transport", "night", "skipass"],

    PFPTT_7: ["train", "transport", "skipass", "materiel"],
    PFPTT_8: ["train", "transport", "night", "skipass", "materiel"],

    PMA: ["passMultiActivities"],
};
